import {IQuestionBase} from '../incase-domain/elements/base/questionElementBase';
import {IPresentation} from '../incase-domain/presentation';
import {IRetriableQuestion} from '../incase-domain/proptypes/runfile';
import {getAttemptsAndRetriable} from '../incase-domain/utils/retryCount';

export function areObjectsEqual(obj1: Record<string, string> = {}, obj2: Record<string, string> = {}): boolean {
    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);

    if (keys1.length !== keys2.length) {
        return false;
    }

    return keys1.every((key) => Object.prototype.hasOwnProperty.call(obj2, key) && obj1[key] === obj2[key]);
}

export function isQuestionRetryLimitReached(
    elementInteractions: IRetriableQuestion,
    element: IQuestionBase,
    presentation: IPresentation | undefined,
    isAnswered: boolean | undefined,
    isCorrect: boolean
): boolean {
    const attemptsData = getAttemptsAndRetriable(element, presentation);
    const hasRemainingRetryAttempts = (elementInteractions.retriedAnswers?.length || 0) < (attemptsData?.maxAttempts || 2) - 1;
    return !isAnswered && (isCorrect || !hasRemainingRetryAttempts);
}

export function isQuestionRetriable(element: IQuestionBase, presentation: IPresentation | undefined): boolean {
    return getAttemptsAndRetriable(element, presentation)?.retriable || false;
}
